import { useEffect, Children, cloneElement } from "react";
import { createPortal } from "react-dom";

const GalleryLightbox = ({
  active,
  children,
  onCloseRequest,
  drop,
  setDrop,
}) => {
  const handleContentAreaClick = (event) => {
    event.preventDefault();

    // Request lightbox close when
    // clicking lightbox content but not on content
    if (event.target === event.currentTarget) {
      onCloseRequest();
    }
  };

  const renderChildren = () => {
    // Clone each child and pass onCloseRequest props
    return Children.map(children, (child) => {
      return cloneElement(child, {
        onCloseRequest,
      });
    });
  };

  useEffect(() => {
    if (drop) {
      const handleKeyDown = (event) => {
        if (event.key === "Escape" && drop) {
          onCloseRequest();
        }
      };

      document.addEventListener("keydown", handleKeyDown);

      return () => document.removeEventListener("keydown", handleKeyDown);
    }
  }, [drop]);

  useEffect(() => {
    if (active) setDrop(true);
    // ? Setting overflow hidden this way prevents the undelying page to scroll to the top when activated
    if (active) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "unset";

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [active]);

  return (
    active &&
    createPortal(
      <div
        className={`fixed top-0 left-0 flex flex-col items-center justify-center transform transition-all duration-150 w-full h-full z-[2100] ${
          drop ? "bg-black/80 backdrop-blur-sm" : "bg-transparent delay-300"
        }`}
        onClick={handleContentAreaClick}
      >
        <div
          className={`fixed top-0 left-0 w-full h-full flex flex-col transform transition-all duration-300 ease-in-out space-y-4 bg-white py-2 rounded-b-lg ${
            drop ? "translate-y-0 delay-150" : "-translate-y-[100%]"
          }`}
        >
          <div
            className="cursor-pointer absolute right-4 z-[2]"
            onClick={onCloseRequest}
          >
            <svg width="30" height="30">
              <g stroke="rgb(0, 0, 0)" strokeWidth="3">
                <line x1="5" y1="5" x2="25" y2="25"></line>
                <line x1="5" y1="25" x2="25" y2="5"></line>
              </g>
            </svg>
          </div>

          <div className="flex flex-grow justify-center w-full h-full overflow-y-auto">
            {renderChildren()}
          </div>
        </div>
      </div>,
      document.body
    )
  );
};

// TODO: Find a way to replace the body style from jsx to tailwind

export default GalleryLightbox;
